export default __webpack_public_path__ + "static/media/CPUImg.0f22e7d4.jpg";